import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useMsal } from '../composition-api/useMsal';
import { loginRequest } from "../authConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInButton',
  setup(__props) {

const { instance } = useMsal();

const loginRedirect = () => {
  instance.loginRedirect(loginRequest);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: "#",
    onClick: loginRedirect,
    class: "inline-block leading-8 p-2 text-white hover:bg-purple"
  }, "Login"))
}
}

})